(function() {
  /*
  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {

    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {

    }
  });
  
  document.addEventListener('theme:cart:init', (e) => {

  });

  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });
  document.addEventListener('theme:resize', e => { console.log(e); });

  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
  */

  let kleepContainer = document.querySelector('.kleep-container');
  let kleepButton = document.querySelector('.kleep-button');
  if (kleepContainer && kleepButton) {
    kleepContainer.append(kleepButton);
  }

  window.addEventListener('message', function(event) {
    if (event.data.action === 'addToCart') {
      
    }
  });

  // loyoly
  let loyolyContainer = document.querySelector('.loy-product-point');
  if (loyolyContainer) {
    loyolyContainer.addEventListener('click', function(){
      window.location.replace("/pages/fidelite-parrainage");
    }, false);
  }
})();

/* ============================================
   COLLECTION - DRAWER FILTERS JS OVERRIDE
   Ajouter dans un fichier JS custom ou dans le theme.liquid
   ============================================ */

(function() {
  'use strict';

  // Observer les changements de classe sur le wrapper des filtres
  // pour gérer le body scroll lock
  const filtersWrapper = document.querySelector('.collection__filters__wrapper');
  if (!filtersWrapper) return;

  // Fonction pour vérifier si le drawer est ouvert
  function isDrawerOpen() {
    return filtersWrapper.classList.contains('filters--visible') ||
           filtersWrapper.classList.contains('is-visible') ||
           filtersWrapper.getAttribute('data-filters-visible') === 'true';
  }

  // Observer les mutations de classe
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'class' || mutation.attributeName === 'data-filters-visible') {
        if (isDrawerOpen()) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      }
    });
  });

  observer.observe(filtersWrapper, {
    attributes: true,
    attributeFilter: ['class', 'data-filters-visible']
  });

  // Fermer le drawer en cliquant sur l'underlay
  const underlay = filtersWrapper.querySelector('.drawer__underlay');
  if (underlay) {
    underlay.addEventListener('click', function() {
      // Déclencher le même toggle que le bouton close
      const closeBtn = filtersWrapper.querySelector('[data-filters-toggle]');
      if (closeBtn) closeBtn.click();
    });
  }
})();